import { DEFAULT_TIME_ZONE_POLICY } from './policy.js';
import { isValidTimeZone } from './validation.js';
export function getDeviceTimeZone() {
    try {
        const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return isValidTimeZone(zone) ? zone : undefined;
    }
    catch {
        return undefined;
    }
}
export function resolveDisplayTimeZone(policy = DEFAULT_TIME_ZONE_POLICY, deviceTimeZone) {
    if (policy.mode === 'FIXED') {
        return isValidTimeZone(policy.fixedTimeZone) ? policy.fixedTimeZone : policy.fallbackTimeZone;
    }
    const candidate = deviceTimeZone ?? getDeviceTimeZone();
    return isValidTimeZone(candidate) ? candidate : policy.fallbackTimeZone;
}
//# sourceMappingURL=resolve-time-zone.js.map